import { render, staticRenderFns } from "./fail-details.vue?vue&type=template&id=6188b664&scoped=true&"
import script from "./fail-details.vue?vue&type=script&lang=ts&"
export * from "./fail-details.vue?vue&type=script&lang=ts&"
import style0 from "./fail-details.vue?vue&type=style&index=0&id=6188b664&prod&lang=scss&"
import style1 from "./fail-details.vue?vue&type=style&index=1&id=6188b664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6188b664",
  null
  
)

export default component.exports